/* Components is an aggregate module which consolidates all of the individual components into a single module.
   Note that each individual component can be used independently by adding a dependency on that module instead of 'components'.
   For example, if you just need httpInterceptor, just add 'http.utils' to your dependency chain and add httpInterceptor.js to your list of includes.
*/
angular.module('components', [
    'http.utils',
    'filters.jsonDate',
    'components.uniform',
    'components.placeholder',
    'components.floatLabel',
    'components.autosize',
    'components.focusOn',
    'components.selectize',
    'components.validation',
    'components.updatePanel',
    'components.makerange',
    'components.more'
]);